import React from "react";
import "../Pages/Terms.css";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { Helmet } from "react-helmet";

export default function Terms() {
  return (
    <>
<Helmet>
  <title>Terms & Conditions | Sri Rajalakshmi Travels</title>
  <meta name="robots" content="noindex" />

  {/* JSON-LD — Travel Agency */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "TravelAgency",
      name: "Sri Rajalakshmi Travels",
      image: "https://srirajalakshmitravels.com/static/media/SRILOGO.538e1e7c6643833d5ce3.png",
      url: "https://srirajalakshmitravels.in",
      telephone: "+91 90952 23243",
      address: {
        "@type": "PostalAddress",
        streetAddress: "12/4 Main Road",
        addressLocality: "Aruppukottai",
        addressRegion: "Tamil Nadu",
        postalCode: "626101",
        addressCountry: "IN",
      },
      openingHours: "Mo-Su 00:00-23:59",
      priceRange: "₹₹",
      sameAs: [
        "https://www.facebook.com/",
        "https://www.instagram.com/"
      ]
    })}
  </script>

  {/* JSON-LD — Services */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Service",
      serviceType: "Van Rental, Car Rental, Tourist Vehicle Booking",
      provider: {
        "@type": "TravelAgency",
        name: "Sri Rajalakshmi Travels",
      },
      areaServed: "Aruppukottai, Virudhunagar",
      hasOfferCatalog: {
        "@type": "OfferCatalog",
        name: "Travel Services",
        itemListElement: [
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Van Rental in Aruppukottai" }},
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Car Rental in Aruppukottai" }},
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Tour Package Booking" }},
        ]
      }
    })}
  </script>
</Helmet>



      <Navbar />

      <section className="terms-section" data-aos="fade-up">

        <h1 className="terms-title">Terms & Conditions</h1>
        <p className="terms-sub">
          Please read the following terms carefully before booking with us.
        </p>

        <div className="terms-box">

          <h2>1. Booking Policy</h2>
          <p>
            • Advance payment is required to confirm the booking.  
            • Bookings are accepted through call or WhatsApp only.  
            • All booking details must be accurate to avoid issues during travel.
          </p>

          <h2>2. Vehicle Usage</h2>
          <p>
            • KM & Hours will be calculated from our office to office basis.  
            • Extra KM or Extra hours will be charged based on the selected package.  
            • Damage caused by passengers will be charged separately.
          </p>

          <h2>3. Driver Policy</h2>
          <p>
            • Driver bata must be paid by the customer.  
            • Driver decision related to routes, safety & timings must be respected.  
            • Misbehaviour with drivers will result in cancellation.
          </p>

          <h2>4. Cancellation Policy</h2>
          <p>
            • Cancellations should be made at least 24 hours in advance.  
            • Advance amount will not be refunded upon cancellation.  
            • Last-minute cancellations will incur additional charges.
          </p>

          <h2>5. Luggage & Safety</h2>
          <p>
            • Heavy or oversized luggage must be informed earlier.  
            • Company is not responsible for loss of personal belongings.  
            • Illegal or hazardous items are strictly prohibited.
          </p>

          <h2>6. Delays & Interruptions</h2>
          <p>
            • Traffic, weather or unavoidable delays are not the company's responsibility.  
            • Alternate route or vehicle arrangement is subject to availability.
          </p>

          <h2>7. Payment Terms</h2>
          <p>
            • Full payment must be made before trip completion.  
            • Digital payment should be confirmed with transaction details.
          </p>

          <h2>8. Liability</h2>
          <p>
            • We ensure well-maintained vehicles and trained drivers.  
            • Company is not liable for natural calamities, accidents, or unexpected issues beyond control.
          </p>

          <h2>9. Acceptance of Terms</h2>
          <p>
            • By booking with SRI RAJALAKSHMI TOURS & TRAVELS, customers agree to all the above terms.
          </p>

        </div>
      </section>

      <Footer />
    </>
  );
}
